import studentMeetingRoutes from "meetings/student/routes";

export default studentMeetingRoutes;
